module.exports = __webpack_public_path__ + "img/assign.af46f5fb.png";